import {
  Text,
  Modal,
  ModalContent,
  ModalFooter,
  Button,
  ModalOverlay,
  ModalBody,
} from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import LoadingBtn from '../../../components/Common/LoadingBtn';
import { QuarantineItemModalName, QuarantineItemModalState } from './interface';
import { useQuarantineReducerContext } from '../Quarantine/context';
import { QuarantineRestoreAllReqDto } from '../utils/types';
import { QUARANTINE_TYPE_NAME_MAP } from '../utils/constants';
import { QuarantineApi } from '@Apis';
import { useLoginUserStore } from '../../../models/useLoginUserModel';
import { isInUIC } from '../../../utils/common';

export const RestoreAllModal = ({
  total,
  modal,
  setModal,
  setTrigger,
}: {
  total: number;
  modal: QuarantineItemModalState;
  setModal: ({ name, quarantineItems }: QuarantineItemModalState) => void;
  setTrigger: () => void;
}) => {
  const { user } = useLoginUserStore();
  const { state: quarantineState, convertCriteriaToSearchItems } =
    useQuarantineReducerContext();
  const { t } = useTranslation(['quarantine', 'common']);
  const onClose = () => {
    setModal({
      name: QuarantineItemModalName.None,
      quarantineItems: modal.quarantineItems,
    });
  };
  const onRestoreAll = async () => {
    const { quarantineType, sort, timeRange, facets } = quarantineState;
    const serviceName = QUARANTINE_TYPE_NAME_MAP.get(quarantineType) as string;
    const i18nServiceName = t(`common:common.service.${serviceName}`);
    const params: QuarantineRestoreAllReqDto = {
      serviceName,
      sort,
      timeRange,
      searches: [...facets, ...convertCriteriaToSearchItems(quarantineState)],
      auditLog: {
        user:
          (isInUIC()
            ? localStorage.getItem('uic_username')
            : user?.loginName) || ' ',
        startMessage: t(
          'quarantine:quarantine.restoreAll.auditLogStartMessage',
          { service: i18nServiceName }
        ),
        stopMessage: t('quarantine:quarantine.restoreAll.auditLogStopMessage', {
          service: i18nServiceName,
          successNum: '{0}',
          failedNum: '{1}',
        }),
        completeMessage: t(
          'quarantine:quarantine.restoreAll.auditLogCompleteMessage',
          {
            service: i18nServiceName,
            successNum: '{0}',
            failedNum: '{1}',
          }
        ),
      },
    };
    try {
      await QuarantineApi.apiRestoreAllQuarantineLogs(params);
      window.showNotification({
        severity: 'success',
        titleMsg: t('quarantine:quarantine.modal.action.successInfo'),
      });
    } catch (e) {
      window.showNotification({
        severity: 'error',
        titleMsg: t('common:common.unknownError'),
      });
    } finally {
      setTrigger();
      onClose();
    }
    console.log('onRestoreAll');
  };

  return (
    <Modal
      ensureFocus={true}
      autoFocus={false}
      closeOnEsc={true}
      closeOnOutsideClick={false}
      isClosable={true}
      isOpen={modal.name === QuarantineItemModalName.Restore}
      onClose={onClose}
      size="sm"
    >
      <ModalOverlay />
      <ModalContent>
        <ModalBody>
          <Text>{t('quarantine.restoreAll.confirmStart', { total })}</Text>
        </ModalBody>
        <ModalFooter gap="8px">
          <LoadingBtn onClick={onRestoreAll} variant="primary">
            {t('common.button.ok')}
          </LoadingBtn>
          <Button onClick={onClose}>{t('common.button.cancel')}</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
